import { keepPreviousData, useQuery } from '@tanstack/react-query';
import qs from 'qs';

import { axios } from 'lib/axios';

const searchSuppliers = async ({ search, competenceAreas, starred, page, limit }) => {
  const queryString = qs.stringify({
    search,
    competence_area_ids: competenceAreas,
    starred: starred || null,
    offset: page * limit,
    limit,
  }, {
    arrayFormat: 'repeat',
    skipNulls: true,
  });

  const { data } = await axios.get(`/api/companies/supplier_search?${queryString}`);

  return data;
};

export const useSearchSuppliers = ({ search, competenceAreas, starred, page, limit }, { enabled = true } = {}) => {
  return useQuery({
    queryKey: ['supplierSearch', search, competenceAreas, starred, page, limit],
    queryFn: () => searchSuppliers({ search, competenceAreas, starred, page, limit }),
    select: ({ data, total }) => ({ suppliers: data ?? [], total: total ?? 0 }),
    placeholderData: keepPreviousData,
    enabled,
  });
};
